import EditIconButton from './EditIconButton';
export default EditIconButton;



// WEBPACK FOOTER //
// ./src/components/EditIconButton/index.js